import React, { useEffect, useState, useRef } from "react";
import { Mic, Square, Play, Trash2, Save } from "lucide-react";
import { uploadAudio } from "../api";
import { toast } from "sonner";

const AudioRecorder = ({ projectId, photoId, existingAudio, onUploadComplete }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(existingAudio);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      chunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          chunksRef.current.push(e.data);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        // setAudioUrl(url); // Preview immediately? No, let's upload first.
        
        // Upload
        try {
          toast.info("Uploading audio...");
          const res = await uploadAudio(projectId, photoId, blob);
          setAudioUrl(res.audio_url);
          toast.success("Audio saved!");
          if (onUploadComplete) onUploadComplete(res.audio_url);
        } catch (err) {
            console.error(err);
            toast.error("Failed to upload audio");
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (err) {
      console.error("Error accessing microphone:", err);
      toast.error("Microphone access denied");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      // Stop all tracks
      mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
    }
  };

  return (
    <div className="flex items-center gap-2 mt-2">
      {isRecording ? (
        <button
          onClick={stopRecording}
          className="flex items-center gap-1 bg-red-100 text-red-600 px-3 py-1.5 rounded-full text-xs font-medium hover:bg-red-200 transition-colors"
        >
          <Square className="w-3 h-3 fill-current" /> Stop Recording
        </button>
      ) : (
        <button
          onClick={startRecording}
          className="flex items-center gap-1 bg-indigo-50 text-indigo-600 px-3 py-1.5 rounded-full text-xs font-medium hover:bg-indigo-100 transition-colors"
        >
          <Mic className="w-3 h-3" /> {audioUrl ? "Record New" : "Add Voice Memory"}
        </button>
      )}

      {audioUrl && !isRecording && (
        <audio controls src={`${process.env.REACT_APP_BACKEND_URL}${audioUrl}`} className="h-8 w-40" />
      )}
    </div>
  );
};

export default AudioRecorder;
